module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/main-visual-text-a570bf574cb1ce389cda9f08bc8393b5.svg";